import React from "react";
import Header from "./parts/header/Header";
import Feed from "./parts/feed/Feed";
import Footer from "./parts/footer/Footer";

function App() {
  return (
    <div>
      <Header />
      <Feed />
      <Footer />
    </div>
  );
}

export default App;